// import { useRef, useState } from "react";
// // import { FileUploader } from "react-drag-drop-files";
// // import dragImg from "../public/the-cloud-icon-13.jpg"
// // import "./styles.css";
// import { common_axios } from "../../../App";

// export default function DragandDrop() {

//   const [files, setFiles] = useState(null);
//   const inputRef = useRef();

//   const[dsiableChooseFile,setDisableChooseFile]=useState(false)
//   const handleDragOver = (event) => {
//     event.preventDefault();
//   };
//   const handleDrop = (event) => {
//     setDisableChooseFile(true)
//     document.getElementById("fileName").value=""
//     event.preventDefault();
//     const file=event.dataTransfer.files[0]
//     console.log("x--",file.name)

//     var idxDot = file.name.lastIndexOf(".") + 1;
//     var extFile = file.name.substr(idxDot, file.name.length).toLowerCase();

//     console.log("en--",extFile)

//       if (extFile == "csv") {
//         setFiles([file]);

//       }
//       else if (extFile == "xlsx") {
//         setFiles([file]);

//       }
//       else {
//       alert("not valid")
//         // toast.error("Only Xlsx files are allowed!");
//         document.getElementById("fileName").value = "";

//       }

//   };
//   console.log("fi--",files)

//   // send files to the server // learn from my other video
//   const handleUpload = () => {
//     alert("uploaded")
//     const formData = new FormData();
//     formData.append("Files", files);
//     console.log("form--",formData)

//   };

//   // if (files) return (
//   //   <div className="uploads">
//   //       <ul>
//   //           {Array.from(files).map((file, idx) => <li key={idx}>{file.name}</li> )}
//   //       </ul>
//   //       <div className="actions">
//   //           <button onClick={() => setFiles(null)}>Cancel</button>
//   //           <button onClick={handleUpload}>Upload</button>
//   //       </div>
//   //   </div>
//   // )

//   async function AccountId() {
//     // alert("hii");
//     // console.log("first");
//     try {
//         // setOpen(true);
//         const formData = new FormData();
//         formData.append("contactListFile", files);
//         // // formData.append("campaignName", formik.values.campaignname);
//         // formData.append("senderId", senderId.senderId);
//         // formData.append("channel", "web");
//         // formData.append("route", "quyeru");
//         // formData.append("templateId", MST == null ? "" : MST?.id);
//         // // formData.append("templateMessage", formik.values.textarea1);
//         // formData.append("smsType", MSG);
//         // formData.append("unicode", LangId == 1 ? "0" : "1");
//         // // unicode: LangId ==1 ? "0" : "1",
//         // formData.append("language", lang);
//         // // formData.append("message", formik.values.textarea1);
//         // formData.append("campaignType", "Individual");
//         // formData.append("campaignSource", "own_numbers_file");
//         // formData.append(
//         //   // "scheduledDatetime",
//         //   // // new Date().toJSON().slice(0, 16)
//         //   // moment(new Date())?.format("YYYY-MM-DD hh:mm:ss")
//         //   "scheduledDatetime",
//         //   moment(value)?.format("YYYY-MM-DD HH:mm:ss")
//         // );
//         // scheduledDatetime: moment(value?.$d)?.format(
//         //   "YYYY-MM-DD HH:mm:ss"
//         // ),
//         // alert("working");
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign/file`,
//           formData
//         );
//         // console.log("resultttttmainnnn", result);
//         if (result.data.statusDescription.statusCode == 200) {
//         //   setOpen(false);
//         //   document.getElementById("fileName").value = "";
//         //   formik.handleReset();
//         //   setCamapaignDropdown(!CamapaignDropdown);
//         //   dispatch(setCampaignState(!CamapaignDropdown));
//         //   dispatch(actionid("1"));
//         //   history.replace("/dashboard/CampaignControl");
//         //   Swal.fire({
//         //     icon: "success",
//         //     //  title: "Oops...",
//         //     text: result.data.statusDescription.statusMessage,
//         //     // footer: '<a href="">Why do I have this issue?</a>'
//         //   });
//           // history.replace("/dashboard/Smsdelivery");
//           // setTargettedArray(result?.data?.responseObject);
//         } else {
//         //   setOpen(false);
//         //   Swal.fire({
//         //     icon: "error",
//         //     title: "Oops...",
//         //     text: result.data.statusDescription.statusMessage,
//         //     // footer: '<a href="">Why do I have this issue?</a>'
//         //   });
//         }
//       } catch (error) {
//         // setOpen(false);

//         // Swal.fire({
//         //   icon: "error",
//         //   title: "Oops...",
//         //   text: "Please Check Your Network",
//         //   // footer: '<a href="">Why do I have this issue?</a>'
//         // });
//       }
//   }

//   const getImage = (e, index) => {
//     const img = e?.target?.files?.[0];
//     // console.log(img, e.target.files[0]);
//     // setSelectedImage(img);
//     var fileName = e?.target?.value;
//     var idxDot = fileName?.lastIndexOf(".") + 1;
//     var extFile = fileName?.substr(idxDot, fileName.length).toLowerCase();
//     // console.log("jj",extFile)
//     // if (extFile == "xlsx") {
//     //   setFilesImage(img);

//     // }
//      if (extFile == "csv") {
//       setFiles(img);
//       // if (Radiosdisabled.choose == true) {
//       //   alert("hfhhf");
//       //   document.getElementById("fileName").value = "";
//       // }
//     }
//     else if (extFile == "txt") {
//       setFiles(img);
//       // if (Radiosdisabled.choose == true) {
//       //   alert("hfhhf");
//       //   document.getElementById("fileName").value = "";
//       // }
//     }
//     else {

//       // toast.error("Only Xlsx files are allowed!");
//       document.getElementById("fileName").value = "";

//     }
//   };
//   return (
//     <>
//          <div
//             className="dropzone"
//             onDragOver={handleDragOver}
//             onDrop={handleDrop}
//             accept=".txt"
//         >
//           {/* <img
//           src={dragImg}
//           alt="loading.."
//           /> */}
//           {
//             files ? (<>
//                    <ul>
//             {Array.from(files).map((file, idx) => <li key={idx}>{file.name}</li> )}
//       </ul>
//             </>):(<>
//               <h1>Drag and Drop Files to Upload</h1>
//             </>)
//           }

//           <h1>Or</h1>
//           {/* <input
//           id="fileName"
//             type="file"
//             multiple
//             onChange={(event) => setFiles(event.target.files)}
//             hidden
//             accept="image/png, image/jpeg"
//             ref={inputRef}
//           /> */}

// <input
//                                                                 // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                                                                 accept=".csv , .txt"
//                                                                disabled={dsiableChooseFile==true}
//                                                                 // required
//                                                                 // value={Files}
//                                                                 id="fileName"
//                                                                 // disabled={FilesImage == null}
//                                                                 type="file"
//                                                                 style={{
//                                                                   color:
//                                                                     "#7b809a",
//                                                                 }}
//                                                                 // onChange={(event) => setFiles(event.target.files)}
//                                                                 onChange={(event) =>{

// // setFiles(event.target.files)
// getImage(event)
// // setChooseFileSelected(true)
// }
// }

//                                                               />

//           {/* {/ <button onClick={() => inputRef.current.click()}>Select Files</button> /} */}
//         </div>
//         <button onClick={() => {setFiles(null)
//         document.getElementById("fileName").value=""
//        setDisableChooseFile(false)
//       }
//         }>Cancel</button>
//          <button
//                                             type="button"
//                                             className="btn resetBtn_UP ms-3 w_btn btn_w8"
//                                           onClick={AccountId}
//                                           >
//                                             Reset

//                                           </button>

//     </>
//   );
// }

import { useRef, useState } from "react";
// import { FileUploader } from "react-drag-drop-files";
// import dragImg from "../public/the-cloud-icon-13.jpg"
// import "./styles.css";

import { common_axios } from "../../../App";

export default function App() {
  const [files, setFiles] = useState(null);
  const [chooseFileSelected, setChooseFileSelected] = useState(false);
  const inputRef = useRef();

  const [dsiableChooseFile, setDisableChooseFile] = useState(false);
  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handleDrop = (event) => {
    setDisableChooseFile(true);
    document.getElementById("fileName").value = "";
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    console.log("x--", file.name);

    var idxDot = file.name.lastIndexOf(".") + 1;
    var extFile = file.name.substr(idxDot, file.name.length).toLowerCase();

    console.log("en--", extFile);

    if (extFile == "csv") {
      setFiles(file);
    } else if (extFile == "xlsx") {
      setFiles([file]);
    } else {
      alert("not valid");
      // toast.error("Only Xlsx files are allowed!");
      document.getElementById("fileName").value = "";
    }
  };
  console.log("fi--", files);

  // send files to the server // learn from my other video
  const handleUpload = () => {
    alert("uploaded");
    const formData = new FormData();
    formData.append("Files", files);
    console.log("form--", formData);
  };

  // if (files) return (
  //   <div className="uploads">
  //       <ul>
  //           {Array.from(files).map((file, idx) => <li key={idx}>{file.name}</li> )}
  //       </ul>
  //       <div className="actions">
  //           <button onClick={() => setFiles(null)}>Cancel</button>
  //           <button onClick={handleUpload}>Upload</button>
  //       </div>
  //   </div>
  // )

  const getImage = (e, index) => {
    const img = e?.target?.files?.[0];
    // console.log(img, e.target.files[0]);
    // setSelectedImage(img);
    var fileName = e?.target?.value;
    var idxDot = fileName?.lastIndexOf(".") + 1;
    var extFile = fileName?.substr(idxDot, fileName.length).toLowerCase();
    // console.log("jj",extFile)
    // if (extFile == "xlsx") {
    //   setFilesImage(img);

    // }
    console.log("jj",extFile)
    if (extFile == "csv") {
      setFiles(img);
      // if (Radiosdisabled.choose == true) {
      //   alert("hfhhf");
      //   document.getElementById("fileName").value = "";
      // }
    } else if (extFile == "txt") {
      setFiles(img);
      // if (Radiosdisabled.choose == true) {
      //   alert("hfhhf");
      //   document.getElementById("fileName").value = "";
      // }
    } else {
      // toast.error("Only Xlsx files are allowed!");
      document.getElementById("fileName").value = "";
    }
  };


  async function AccountId() {
    try {
      // setOpen(true);
      const formData = new FormData();
      if (dsiableChooseFile == true) {
        Array.from(files).forEach((file) => {
          formData.append("contactListFile", file);
        });
      } else {
        formData.append("contactListFile", files);
      }


      // formData.append("contactListFile", files);
      // // formData.append("campaignName", formik.values.campaignname);
      // formData.append("senderId", senderId.senderId);
      // formData.append("channel", "web");
      // formData.append("route", "quyeru");
      // formData.append("templateId", MST == null ? "" : MST?.id);
      // // formData.append("templateMessage", formik.values.textarea1);
      // formData.append("smsType", MSG);
      // formData.append("unicode", LangId == 1 ? "0" : "1");
      // // unicode: LangId ==1 ? "0" : "1",
      // formData.append("language", lang);
      // // formData.append("message", formik.values.textarea1);
      // formData.append("campaignType", "Individual");
      // formData.append("campaignSource", "own_numbers_file");
      // formData.append(
      //   // "scheduledDatetime",
      //   // // new Date().toJSON().slice(0, 16)
      //   // moment(new Date())?.format("YYYY-MM-DD hh:mm:ss")
      //   "scheduledDatetime",
      //   moment(value)?.format("YYYY-MM-DD HH:mm:ss")
      // );
      // scheduledDatetime: moment(value?.$d)?.format(
      //   "YYYY-MM-DD HH:mm:ss"
      // ),
      // alert("working");
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/campaign/v1/schedule-campaign/file`,
        formData
      );
      // console.log("resultttttmainnnn", result);
      if (result.data.statusDescription.statusCode == 200) {
        //   setOpen(false);
        //   document.getElementById("fileName").value = "";
        //   formik.handleReset();
        //   setCamapaignDropdown(!CamapaignDropdown);
        //   dispatch(setCampaignState(!CamapaignDropdown));
        //   dispatch(actionid("1"));
        //   history.replace("/dashboard/CampaignControl");
        //   Swal.fire({
        //     icon: "success",
        //     //  title: "Oops...",
        //     text: result.data.statusDescription.statusMessage,
        //     // footer: '<a href="">Why do I have this issue?</a>'
        //   });
        // history.replace("/dashboard/Smsdelivery");
        // setTargettedArray(result?.data?.responseObject);
      } else {
        //   setOpen(false);
        //   Swal.fire({
        //     icon: "error",
        //     title: "Oops...",
        //     text: result.data.statusDescription.statusMessage,
        //     // footer: '<a href="">Why do I have this issue?</a>'
        //   });
      }
    } catch (error) {
      // setOpen(false);
      // Swal.fire({
      //   icon: "error",
      //   title: "Oops...",
      //   text: "Please Check Your Network",
      //   // footer: '<a href="">Why do I have this issue?</a>'
      // });
    }
  }

  return (
    <>
      <div
        className="dropzone"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        accept=".txt"
      >
        {/* <img
          src={dragImg}
          alt="loading.."
          /> */}
        {files && chooseFileSelected == false ? (
          <>
            {/* <ul>
              {Array.from(files).map((file, idx) => (
                <li key={idx}>{file.name}</li>
              ))}
            </ul> */}
            <p>
                {
                    files?.name
                }
            </p>
          </>
        ) : (
          <>
            <h1>Drag and Drop Files to Upload</h1>
          </>
        )}

        <h1>Or</h1>
        {/* <input 
          id="fileName"
            type="file"
            multiple
            onChange={(event) => setFiles(event.target.files)}
            hidden
            accept="image/png, image/jpeg"
            ref={inputRef}
          /> */}

        <input
          // accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          accept=".csv , .txt"
          disabled={dsiableChooseFile == true}
          // required
          // value={files}
          id="fileName"
          // disabled={FilesImage == null}
          type="file"
          style={{
            color: "#7b809a",
          }}
          //    onChange={(event) =>{

          // // setFiles(event.target.files)
          // getImage(event)
          // setChooseFileSelected(true)
          // }
          // }
          onChange={(event) => {
            // setFiles(event.target.files)
            getImage(event);
            setChooseFileSelected(true);
          }}
        />

        {/* {/ <button onClick={() => inputRef.current.click()}>Select Files</button> /} */}
      </div>
      <button
        onClick={() => {
          setFiles(null);
          document.getElementById("fileName").value = "";
          setDisableChooseFile(false);
          setChooseFileSelected(false);
        }}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn resetBtn_UP ms-3 w_btn btn_w8"
        onClick={AccountId}
      >
        Reset
      </button>
    </>
  );
}
